<p-dialog [style]="{width: '70vw'}" [(visible)]="display" appendTo="body" [modal]="true" (onHide)="close()">
  <p-header>
    {{'Address.SameAddress.Title' | translate}}
  </p-header>

  <p class="ml-1">{{getMessageText()}}</p>

  <div style="max-height: 400px; overflow: auto;">
    <p-table class="datatable" [value]="candidates" styleClass="p-datatable-gridlines">
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width:8%">
          <col style="width:15%">
          <col style="width:15%">
          <col style="width:62%">
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>
            <p-checkbox [ngModel]="isAllSelected()" (onChange)="toggleSelectAll($event.checked)" [binary]="true"></p-checkbox>
          </th>
          <th>{{'Address.SameAddress.Column.DoNo' | translate}}</th>
          <th>{{'Address.SameAddress.Column.Facility' | translate}}</th>
          <th>{{'Address.SameAddress.Column.Address' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr class="same-address-row" [class.same-address-row-selected]="selected[row.doNo]" (click)="toggleRow(row.doNo)">
          <td (click)="$event.stopPropagation()">
            <p-checkbox [(ngModel)]="selected[row.doNo]" [binary]="true"></p-checkbox>
          </td>
          <td>{{row.doNo}}</td>
          <td>{{row.facility}}</td>
          <td>{{row.address}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-footer>
    <button type="button" pButton [label]="'Address.SameAddress.Button.Done' | translate" (click)="close()"></button>
  </p-footer>
</p-dialog>
